export default __webpack_public_path__ + "static/media/avatar.8c7d8f19.svg";